var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isCompany)?_c('company-requests',{attrs:{"company":_vm.companyData,"user":_vm.companyUserData}}):_vm._e(),_vm._v(" "),(_vm.isCustomer)?_c('customer-requests',{attrs:{"user":_vm.customerUserData,"requests":_vm.customerRequests}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c7e9a27","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/my-pages-sublayouts/MyPagesRequests.vue
// module id = 1350
// module chunks = 0